import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FieldDetailsFragmentGql } from './FieldDetailsFragmentGql';

export const LensFieldDetailsQueryGql: DocumentNode = gql`
query LensFieldDetailsQuery($lensFieldId: ID!) {
  lensFields(filter: { id: $lensFieldId }){
    name
    description
    datasourceField {
      datasource {
      ...on PublishedDatasource {
          vizportalId
        }
      }
      ...FieldDetailsFragment
    }
  }
}
${FieldDetailsFragmentGql}
`;
